module.exports = __webpack_public_path__ + "img/wp-new-habit-card7.4c5d83da.jpg";